import React, { useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import './DualRangeSlider.css';

interface DualRangeSliderProps {
  min: number;
  max: number;
  step: number;
  unit: string;
  initialMin?: number;
  initialMax?: number;
  onChange: (minValue: number, maxValue: number) => void;
}

const DualRangeSlider: React.FC<DualRangeSliderProps> = ({
  min,
  max,
  step,
  unit,
  initialMin = min,
  initialMax = max,
  onChange
}) => {
  const [minValue, setMinValue] = useState<number>(initialMin);
  const [maxValue, setMaxValue] = useState<number>(initialMax);

  useEffect(() => {
    // Initialize with provided values
    setMinValue(initialMin);
    setMaxValue(initialMax);
  }, [initialMin, initialMax]);

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMinValue = Math.min(Number(e.target.value), maxValue - step);
    setMinValue(newMinValue);
    onChange(newMinValue, maxValue);
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMaxValue = Math.max(Number(e.target.value), minValue + step);
    setMaxValue(newMaxValue);
    onChange(minValue, newMaxValue);
  };

  // Calculate the percentage position for the range track fill
  const getTrackFillStyle = () => {
    const minPercent = ((minValue - min) / (max - min)) * 100;
    const maxPercent = ((maxValue - min) / (max - min)) * 100;
    
    return {
      left: `${minPercent}%`,
      width: `${maxPercent - minPercent}%`
    };
  };

  return (
    <div className="dual-range-slider">
      <div className="slider-container">
        <div className="slider-track"></div>
        <div className="slider-track-fill" style={getTrackFillStyle()}></div>
        
        <input
          type="range"
          className="slider-thumb min-thumb"
          min={min}
          max={max}
          step={step}
          value={minValue}
          onChange={handleMinChange}
          title={`Minimum ${unit} value`}
          aria-label={`Minimum ${unit} value`}
        />
        
        <input
          type="range"
          className="slider-thumb max-thumb"
          min={min}
          max={max}
          step={step}
          value={maxValue}
          onChange={handleMaxChange}
          title={`Maximum ${unit} value`}
          aria-label={`Maximum ${unit} value`}
        />
      </div>
      
      <Row className="slider-values mt-2">
        <Col xs={6} className="text-start">
          <Form.Label className="wind-form-label color-silver">
            {minValue} {unit}
          </Form.Label>
        </Col>
        <Col xs={6} className="text-end">
          <Form.Label className="wind-form-label color-silver">
            {maxValue} {unit}
          </Form.Label>
        </Col>
      </Row>
    </div>
  );
};

export default DualRangeSlider;
